import {Outlet} from "react-router-dom";

const Teams = () => {

    return (
        <Outlet />
    )
}

export default Teams